
const data = [
  {
    title: '财务及税务筹划服务概述',
    description: '专业的财务及税务筹划服务，减轻企业税收负担，降低企业成本。'
  },
  {
    title: '服务内容',
    description: '财税筹划方案\n' +
      '税收洼地\n' +
      '税收优惠申请'
  },
  {
    title: '服务特点',
    description: '省时间、合法合规、节税多。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/product-design.js